import Header from "./components/Header";
import Hero from "./sections/Hero";
import SocialProofSection from "./sections/SocialProofSection";
import ProblemSection from "./sections/ProblemSection";
import SolutionSection from "./sections/SolutionSection";
import CreatorsSection from "./sections/CreatorsSection";
import PartnersSection from "./sections/PartnersSection";
import TeamSection from "./sections/TeamSection";
import DownloadSection from "./sections/DownloadSection";
import ContactFooterSection from "./sections/ContactFooterSection";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <SocialProofSection />
        <ProblemSection />
        <SolutionSection />
        <CreatorsSection />
        <PartnersSection />
        <TeamSection />
        <DownloadSection />
        <ContactFooterSection />
      </main>
    </div>
  );
}

export default App;
